import { render, staticRenderFns } from "./FormSpinbuttonValidation.vue?vue&type=template&id=2952ec99&"
import script from "./FormSpinbuttonValidation.vue?vue&type=script&lang=js&"
export * from "./FormSpinbuttonValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports